import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CoveragesComponent } from './coverages.component';

const routes: Routes = [{ path: '', component: CoveragesComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CoveragesRoutingModule { }
